import { render, staticRenderFns } from "./HistoricoPedidos.vue?vue&type=template&id=296c2434"
import script from "./HistoricoPedidos.vue?vue&type=script&lang=js"
export * from "./HistoricoPedidos.vue?vue&type=script&lang=js"
import style0 from "./HistoricoPedidos.vue?vue&type=style&index=0&id=296c2434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports